import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, SvgIconModule } from '@hdms/shared/ui-core';
import { LetModule } from '@hdms/shared/util-core';

import { SelectLanguageComponent } from './select-language.component';

@NgModule({
  declarations: [SelectLanguageComponent],
  imports: [CommonModule, ButtonModule, SvgIconModule, LetModule],
  exports: [SelectLanguageComponent]
})
export class SelectLanguageModule {}
